import { formTableRow } from "./types";

export const formTableRowData: formTableRow[] = [
  {
    fileName: "BOOKS.FORMS_DATA.ALUM_FLOOR.fileName",
    formName: "BOOKS.FORMS_DATA.ALUM_FLOOR.formName",
    group: 2,
    sort: 2,
  },
  {
    fileName: "BOOKS.FORMS_DATA.ALUM_COLUMN.fileName",
    formName: "BOOKS.FORMS_DATA.ALUM_COLUMN.formName",
    group: 4,
    sort: 20,
  },
  {
    fileName: "BOOKS.FORMS_DATA.CRANE_BACK_WALL.fileName",
    formName: "BOOKS.FORMS_DATA.CRANE_BACK_WALL.formName",
    group: 1,
    sort: 1,
  },
];

export default formTableRowData